import React, {useState} from 'react';
import FilterOrderBy from './filters/FilterOrderBy';

function summary(props) {
  const [modalVisible, setModalVisible] = useState(false);

  const {
    layout,
    filters,
    results,
    currentSearchTerm,
    selected,
    mobileStyle,
    displayPostCounts,
    order,
    autoLoadFilters,
    filterReset,
    sidebarLeft,
    sidebarRight,
    displayReset,
    displayResults,
    displaySort,
    displaySearch,

    orderChange,
    toggleSelected,
    replaceSelected,
    isSelected,
    resetSelected,
    searchFieldChange,
    setFilterReset
  } = props;

  let totalResults;
  let sortComponent;

  if (displayResults) {
    totalResults = <div className="eight29-filter-summary-results">
      <span>Showing {results} Ranches</span>
    </div>
  }

  if (displaySort) {
    sortComponent = <FilterOrderBy
        order={order}
        orderChange={orderChange}
    ></FilterOrderBy>
  }

  return (
    <div className="eight29-filter-summary">
        {totalResults}
        {sortComponent}
    </div>
  );
}

export default summary;